import React from "react";
import {
  Box,
  Flex,
  Img,
  Text,
  Link as ChakraLink,
} from "@chakra-ui/react";

const ArticlesPage = () => {

  const articles = [
    {
      imageUrl: "/aptofyinsight.png",
      title: "Streamline hiring with AI",
      content: (
        <>
          <Text fontSize="lg">
            Streamline hiring, enhance candidate evaluations, and ensure a
            bias-free, efficient process. Embrace advanced AI and seamless video
            analysis to drive success.
          </Text>
          <Text fontSize="lg">
            Ready to transform your recruitment strategy?{" "}
            <ChakraLink
              href="https://www.aptofy.com/"
              color="blue"
              textDecoration="underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </ChakraLink>{" "}
            to learn more and get started today!
          </Text>
          <Text fontSize="lg">Book a Demo with us</Text>
          <Text fontSize="lg">
            M-+91-7892384749
          </Text>
          <Text fontSize="lg">
            E-aptofycare@unlimiteye.com
          </Text>
        </>
      ),
      linkedinLink:
      "https://www.linkedin.com/pulse/unlocking-organizational-success-power-managed-talent-acquisition-dipdc/?trackingId=ia6LgA%2FFrKvPYkIc77FN3g%3D%3D"
    },
    {
      imageUrl: "/aptofyinsight1.png",
      title: "Unlock candidate potential",
      content: (
        <Text fontSize="lg" ml={2}>
          Unlock candidate potential with Aptofy's cutting-edge communication
          skill analysis. Elevate evaluation standards for hiring success. Our
          comprehensive approach ensures unbiased assessments, empowering your
          recruitment process. Partner with us to discover top-tier talent
          efficiently. Upgrade your hiring strategy with Aptofy today.
        </Text>
      ),
      linkedinLink:
      "https://www.linkedin.com/pulse/elevating-candidate-evaluation-through-comprehensive-communication-fbvrc/?trackingId=5KJO8dNHzexeUAqzLG15lQ%3D%3D"
    },
    {
      imageUrl: "/aptofy insight2.png",
      title: "Adopting dark mode for energy efficiency",
      content: (
        <Text fontSize="lg">
         Using dark mode and darker screen colors cuts energy use and lowers electronic device carbon footprints. OLED and AMOLED screens, 
         especially in black, consume less power. Dark mode displays primarily black and dark gray, 
         reducing energy needs. Integrating deep blues and muted colors saves more energy, lessening charging
          cycles and overall electricity consumption. This conserves energy, cuts greenhouse gases, and encourages
           widespread adoption of Dark Mode
        </Text>
      ),
      linkedinLink:
      "https://www.linkedin.com/pulse/world-environment-day-switch-dark-mode-aptofy-073wc/?trackingId=o%2FJ94A0waTmKPEjKA1LnNA%3D%3D"
    },
    {
      imageUrl: "/aptofy insight4.png",
      title: "AI bots revolutionizing recruitment",
      content: (
        <Text fontSize="lg" ml={2}>
          The transformation of talent acquisition with artificial intelligence relieves employees from 
          the burdensome tasks of conducting interviews and sorting through resumes. This liberation allows
          them to redirect their time and energy towards their work, tasks, and personal lives, thereby
          fostering a healthier work-life balance and enhancing overall productivity.
        </Text>
      ),
      linkedinLink:
      "https://www.linkedin.com/pulse/transformation-talent-acquisition-how-ai-bots-revolutionising-recruitment-m2poc/?trackingId=K2NkxeeCLj1yAoa%2BV0V2kQ%3D%3D",
    },
    {
      imageUrl: "/aptofy insight5.png",
      title: "AI bots revolutionizing recruitment",
      content: (
        <Text fontSize="lg" ml={2}>
        Protecting trainers' intellectual property (IP) is crucial in the digital age.
         Training materials and curated content are vulnerable to unauthorized use,
          undermining their value and discouraging innovation. Organizations can safeguard 
          these assets by restricting downloads, detecting misuse, ensuring exam integrity,
           and monitoring content. These measures preserve quality, foster trust, and uphold
            the credibility of learning programs.
        </Text>
      ),
      linkedinLink:
      "https://www.linkedin.com/pulse/protecting-trainers-intellectual-property-learning-ecosystems-gupta-fz15c/?trackingId=tfGytdryTBun6C2ibSAAZg%3D%3D",
    },
    {
      imageUrl: "/aptofy insight6.png",
      title: "",
      content: (
        <Text fontSize="lg" ml={2}>
      In today’s fast-paced world, talent acquisition is more than just hiring the right people;
       it’s about fostering fairness, inclusivity, and efficiency. Artificial Intelligence (AI)
        is playing a pivotal role in transforming this process, making it both kinder and more 
        effective.
        Here’s how AI is reshaping talent acquisition:
        </Text>
      ),
      linkedinLink:
      "https://www.linkedin.com/pulse/empathy-meets-efficiency-how-ai-revolutionizing-talent-manjari-gupta-0lqoc/?trackingId=EVqtRFucQLeDHyIhuVJg3g%3D%3D",
    },
  ];

  return (
    <div>
      <h1
        style={{
          textAlign: "center",
          fontWeight: "bold",
          marginTop: "20px",
          fontSize: "26px",
          color: "#666",
        }}
      >
        Welcome to our articles page! 
      </h1>

      {articles.map((article, index) => (
        <Flex
          key={index}
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="space-between"
          p={5}
          flexDirection={index % 2 === 0 ? "row" : "row-reverse"}
        >
          <Box flex="1" mr={{ base: 0, md: index % 2 === 0 ? 5 : 0 }} mb={{ base: 5, md: 0 }} mt={{ base: index === 0 ? 5 : 0 }}>
            {article.content}
            <Text fontSize="lg">
              <ChakraLink
                href={article.linkedinLink}
                color="blue.500"
                textDecoration="underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Read More 
              </ChakraLink>
            </Text>
          </Box>

          <Box flex="1" mt={{ base: 5, md: 0 }} ml={{ base: 0, md: index % 2 === 0 ? 0 : 5 }}>
            <img
              src={article.imageUrl}
              alt="Insights Image"
              style={{ width: "100%", height: "auto" }}
            />
          </Box>
        </Flex>
      ))}
    </div>
  );
};

export default ArticlesPage;
